// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';

import { BubbleRatingWithReviewCount } from '@ta/styleguide.bubble-rating';
import { Link } from '@ta/common.routing';
import Logging from '@ta/common.logging';
import { QueriedTripFlowSelector } from '@ta/trips.trip-flow-selector';
import { BookmarkIcon } from '@ta/trips.bookmark-icon';
import { InteractionLogger } from '@ta/tracking.interactions';
import { NoPhotoAvailableByPlaceType } from '@ta/social.place-type';

import LocationSectionPhotoWrap from './LocationSectionPhotoWrap';

import styles from './LocationSection.less';

const buildLocationUrlForCard = (location: any) => {
  if (location && location.url) {
    Logging.warn('LocationSection using location.url instead of location.route.url!');
  }
  return location?.route?.url || location?.url;
};

type Props = {
  /** The json location object */
  location: any,
};

const LocationSection = ({ location }: Props) => {
  const hasPhotos = location.thumbnail;

  if (location.isGeo) {
    return (
      <div className={`ui_shelf_item_container ui_geo_shelf_item ${styles.section} `}>
        <InteractionLogger>
          {logFeedClick => (
            <Link
              href={buildLocationUrlForCard(location)}
              onClick={e => logFeedClick(e, 'feedClick')}
              className="ui_poi_thumbnail ui_text_on_thumbnail"
            >
              {hasPhotos ? (
                <LocationSectionPhotoWrap location={location} geoShelfPhotoClassName="" />
              ) : (
                <NoPhotoAvailableByPlaceType location={location} />
              )}
              <span className="item name">{location.name}</span>
            </Link>
          )}
        </InteractionLogger>
      </div>
    );
  }
  return (
    <div className={styles.section}>
      <QueriedTripFlowSelector object={location}>
        {(openFlow, active) => (
          <BookmarkIcon bookmarkStyle="stacked" active={active} onClick={openFlow} />
        )}
      </QueriedTripFlowSelector>
      <InteractionLogger>
        {logFeedClick => (
          <React.Fragment>
            <Link
              href={location.url}
              className="ui_poi_thumbnail"
              onClick={e => logFeedClick(e, 'feedClick')}
            >
              {hasPhotos ? (
                <LocationSectionPhotoWrap location={location} geoShelfPhotoClassName="" />
              ) : (
                <NoPhotoAvailableByPlaceType location={location} />
              )}
            </Link>
            <Link
              href={location.url}
              className="item poi_name ui_link"
              onClick={e => logFeedClick(e, 'feedClick')}
            >
              <span className={styles.name}>{location.name}</span>
            </Link>

            {location.reviewSummary && location.reviewSummary.count !== 0 && (
              <Link href={location.url} onClick={e => logFeedClick(e, 'feedClick')}>
                <BubbleRatingWithReviewCount
                  numReviews={location.reviewSummary.count}
                  rating={location.reviewSummary.rating}
                  fontSize={14}
                />
              </Link>
            )}
          </React.Fragment>
        )}
      </InteractionLogger>
      <span className={styles.subheader}>{location.geoName}</span>
    </div>
  );
};

export default LocationSection;
